import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import CacheBuster from "../utils/cacheBuster";
import React, {useEffect} from "react";
import * as actions from "../store/actions";
import api from "../store/api/api";
import {useDispatch, useSelector} from "react-redux";
import {useUser, useAuthStatus, pathWithMfaGate} from "./auth";
import AnonTemplate from "../components/templates/AnonTemplate";
import {setCampaignList, setMemberships} from "../store/actions";

export default function Root() {

    const focusedCampaign = useSelector(state => state.session.focusedCampaign);
    const permissions = useSelector(state => state.permissions);
    const dispatch = useDispatch();
    const me = useUser();
    const navigate = useNavigate();
    const location = useLocation();
    const [auth] = useAuthStatus();

    useEffect(() => {
        if (me) {
            console.log('me', me)
            dispatch(actions.setAccessToken("obsoletetoken"));
            dispatch(actions.setRefreshToken("obsoletetoken"));
            if (permissions.loading) {
                api.get("myaccount/").then((res) => {
                    console.log('pass to redux', res.data)
                    const { memberships, ...account } = res.data;
                    dispatch(setCampaignList(memberships.map(m => m.campaign)));
                    dispatch(setMemberships(memberships, account));
                    if (location.pathname === '/startup') {
                        const target = pathWithMfaGate(account.profile ?? {}, auth, '/select-campaign');
                        navigate(target);
                    }
                })
            } else if (location.pathname === '/') {
                if (!focusedCampaign || !focusedCampaign.id) {
                    const target = pathWithMfaGate(permissions, auth, '/select-campaign');
                    navigate(target);
                } else if (permissions.memberships && permissions.memberships.length > 0 && focusedCampaign) {
                    navigate('/dash');
                } else {
                    const target = pathWithMfaGate(permissions, auth, '/select-campaign');
                    navigate(target);
                }
            } else if (!focusedCampaign || !focusedCampaign.id) {
                const target = pathWithMfaGate(permissions, auth, '/select-campaign');
                navigate(target);
            }
        }
    }, [me, focusedCampaign, permissions, auth])

    const Wrapper = !me ? AnonTemplate : React.Fragment;

    return (
        <Wrapper>
            <CacheBuster/>
            <Outlet />
        </Wrapper>
    )
}
